/**
 * Combine predicates using logical AND.
 *
 * @example
 * const depends = whenAll(isChild, isCollegeAge);
 *
 * @param {...Function} preds - Predicates to combine
 * @returns {Function} Predicate that returns true when all predicates pass
 */
export const whenAll =
  (...preds) =>
  (...args) =>
    preds.every(p => p(...args));

/**
 * Combine predicates using logical OR.
 *
 * @example
 * const depends = whenAny(hasCertifierAddress, hasSponsorAddress);
 *
 * @param {...Function} preds - Predicates to combine
 * @returns {Function} Predicate that returns true when any predicate passes
 */
export const whenAny =
  (...preds) =>
  (...args) =>
    preds.some(p => p(...args));

/**
 * Negate a predicate.
 *
 * @example
 * const sponsorIsAlive = whenNot(sponsorIsDeceased);
 *
 * @param {Function} pred - Predicate to negate
 * @returns {Function} Negated predicate
 */
export const whenNot =
  pred =>
  (...args) =>
    !pred(...args);
